import type { ChipProps } from '@pixum/chip';

/**
 * Create chip props from nodes with anchors. Is used to create chips for magazine and card groups.
 *
 * @param nodes - Array of nodes containing anchor properties
 * @returns Array of chip props with labels derived from anchors
 *
 * @template T - Generic type extending an object with an optional anchor property
 */
export function createChipProps<T extends { anchor?: string }>(nodes: T[]): ChipProps[] {
  return nodes
    .filter(node => !!node.anchor)
    .map(node => ({
      label: node.anchor as string,
    }));
}
